import React from 'react';
import styled from 'styled-components';

const MIN_BAR_WIDTH = 40;

const MiniQuestionChart = ({ data, title }) => {
    if (!data || data.length === 0) return null;
    const items = data.filter((d) => (d.count ?? 0) > 0);
    return (
        <Row>
            <Label title={title}>{title}</Label>
            <Chart>
                {items.map((item, idx) => (
                    <Section key={idx} width={item.data?.[0] ?? 0}>
                        <Bar color={item.color}>
                            <Pct>{Math.round(item.data?.[0] ?? 0)}%</Pct>
                        </Bar>
                    </Section>
                ))}
            </Chart>
        </Row>
    );
};

export default MiniQuestionChart;

const Row = styled.div`
    display: grid;
    grid-template-columns: 200px 1fr;
    gap: 12px;
    width: 100%;
    align-items: center;
`;

const Label = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #111827;
    font-weight: 600;
`;

const Chart = styled.div`
    display: flex;
    gap: 2px;
    height: 20px;
    background: #f9fafb;
    border-radius: 6px;
    padding: 2px;
`;

const Section = styled.div`
    width: ${(p) => p.width}%;
    min-width: ${MIN_BAR_WIDTH}px;
`;

const Bar = styled.div`
    width: 100%;
    height: 100%;
    background: ${(p) => p.color};
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 700;
    font-size: 11px;
`;

const Pct = styled.span``;

